/**
 * =============================================================================
 * video-slider-manager.js
 * =============================================================================
 * Generate VideoSlider objects for all video slider on page.
 * =============================================================================
 */

import VideoSlider from "./video-slider";

var VideoSliderManager = {
  sliders: {},

  init: function() {
    // Get all of the video sliders. This will usually just be 1 (i.e the
    // product page), but could be multiple (i.e. multiple sections on a JSON
    // template using the 'featured-product' section)
    let sections = document.querySelectorAll(".section-video-slider");
    sections.forEach(section => {
      let videoSlider = new VideoSlider(section); 
      this.sliders[section.id] = videoSlider;
    });
  } 
}

export default VideoSliderManager;